import { useContext, useMemo } from "react";
import countries from "../../../../../../../constants/validation-pulldown-options/countries";
import ThemeContext from "../../../../../../../context/theme/ThemeContext";
import validation from "../../../../../../../constants/validation";
import commodityCodeTypes from "../../../../../../../constants/validation-pulldown-options/commodityCodeTypes";
import ListItem, { ListItemSubTitle, ListItemTitle } from "../../../../../../common/ListItem";

const DrawerItem = (props) => {
	const { withTheme } = useContext(ThemeContext);
	const { item, searchType, onClick, isSelected } = props;

	const itemData = useMemo(() => {
		let itemData = {};
		if (searchType === "contacts") {
			itemData = item.jdeclaration?.data?.contact;
		} else if (searchType === "locationOfGoods") {
			itemData = item.goodsLocation?.data;
		} else if (searchType === "commodityCodes") {
			itemData = item.commodityCodes?.data;
		}

		return itemData || {};
	}, [item]);

	return (
		<ListItem isSelected={isSelected} onClick={() => onClick(item)}>
			{searchType === "contacts" && (
				<div>
					<ListItemTitle style={{ fontWeight: 600 }}>
						{itemData.contactName}
					</ListItemTitle>

					<ListItemSubTitle
						style={{ display: "flex", alignItems: "center", gap: 12, marginTop: 4 }}
					>
						{itemData.contactCountry ? (
							<div style={{ fontSize: 12 }}>{itemData.contactCountry}</div>
						) : null}
						{itemData.contactCity ? (
							<div style={{ fontSize: 12 }}>
								{itemData.contactCity || "None"}
							</div>
						) : null}
					</ListItemSubTitle>
				</div>
			)}

			{searchType === "locationOfGoods" && (
				<div>
					<div className={withTheme("search-page-drawer-item-title")}>
						{countries.find(
							(country) => country.key === itemData.locationOfGoodsCountry
						)?.value || itemData.locationOfGoodsCountry}
					</div>

					<div style={{ display: "flex", alignItems: "center" }}>
						<div style={{ display: "flex", alignItems: "center" }}>
							<div className={withTheme("item-property")}>Type:</div>
							<div style={{ fontSize: 12 }}>
								{validation
									.find(
										({ elementName }) =>
											elementName ===
											"locationOfGoodsType"
									)
									?.pullDownMenu.find(
										({ key }) =>
											key ===
											itemData.locationOfGoodsType
									)?.value || itemData.locationOfGoodsType}
							</div>
						</div>
						<div style={{ marginLeft: 24, display: "flex", alignItems: "center" }}>
							<div className={withTheme("item-property")}>ID:</div>
							<div style={{ fontSize: 12 }}>{itemData.locationOfGoodsId}</div>
						</div>
					</div>
				</div>
			)}

			{searchType === "commodityCodes" && (
				<div>
					<div className={withTheme("search-page-drawer-item-title")}>
						{commodityCodeTypes.find(
							({ key }) => key === itemData.commodityCodeType
						)?.value || itemData.commodityCodeType}
					</div>

					<div style={{ display: "flex", alignItems: "center" }}>
						<div className={withTheme("item-property")}>ID:</div>
						<div style={{ fontSize: 12 }}>{itemData.commodityCodeId}</div>
					</div>
				</div>
			)}
		</ListItem>
	);
};

export default DrawerItem;
